<template>
  <div></div>
</template>

<script>
export default {
  name: "CityConfig",
  components: {},
};
</script>

<style scoped>
</style>
